import styled from 'styled-components';
import { Controller, useForm } from 'react-hook-form';
import Select from 'react-select';
import { UserFavorList } from '../../../components/user/favor/user.favor.company.list';
import { useState } from 'react';
import { fetchPreferenceCompanyList } from '../../../api/preference';
import { addressCollection } from '../../../utils/address';
import { Button } from '../../../components/items/Button';
import { useHistory } from 'react-router-dom';

interface PreferenceCompanyResponse {
  id: number;
  name: string;
  preferred: boolean;
  address: string;
  detail: string;
}

const UserFavorComp = () => {
  const { handleSubmit, control, watch } = useForm();
  const [listData, setListData] = useState<PreferenceCompanyResponse[]>([]);
  const history = useHistory();

  const [selectedRegion, setSelectedRegion] = useState<{
    label: string;
    value: string;
    gu: { label: string; value: string }[];
  } | null>(null);

  const gu = watch('gu'); // watch로 gu 상태를 추적

  const fetchCompanyList = async (city: string = '', gu: string = '') => {
    try {
      const response = await fetchPreferenceCompanyList({
        cityProvince: city,
        district: gu,
      });
      setListData(response);
    } catch (error) {
      console.error(error);
    }
  };

  const onSubmit = async (data: any) => {
    const guValue = data.gu || ''; // gu 값이 없으면 빈 문자열로 설정
    await fetchCompanyList(data.city, guValue);
  };

  // 등록 또는 취소 후 목록 새로 고침
  const handleRegisterSuccess = () => {
    const city = selectedRegion?.value || ''; // 선택된 시도 값이 없으면 빈 문자열
    const guValue = gu || ''; // gu가 선택되지 않았다면 빈 문자열을 사용
    fetchCompanyList(city, guValue);
  };

  const clickHandlerListView = () => {
    history.push('/user/favor/company/list');
  };
  return (
    <Container>
      <SearchForm>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row-50">
            <div className="select-wrapper">
              <Controller
                name="city"
                control={control}
                render={({ field }) => (
                  <Select
                    className="search-select"
                    classNamePrefix="react-select"
                    options={addressCollection}
                    onChange={(selectedOption) => {
                      setSelectedRegion(selectedOption);
                      field.onChange(selectedOption?.value);
                      handleSubmit(onSubmit)(); // 선택 변경 시 자동 제출
                    }}
                    value={selectedRegion}
                    components={{ IndicatorSeparator: () => null }}
                    placeholder="시도 선택"
                    maxMenuHeight={200}
                  />
                )}
              />
            </div>
            <div className="select-wrapper">
              <Controller
                name="gu"
                control={control}
                render={({ field }) => (
                  <Select
                    className="search-select"
                    classNamePrefix="react-select"
                    options={selectedRegion ? selectedRegion.gu : []}
                    onChange={(val) => {
                      field.onChange(val ? val.value : null);
                      handleSubmit(onSubmit)(); // 선택 변경 시 자동 제출
                    }}
                    value={
                      selectedRegion?.gu.find(
                        (g: { label: string; value: string }) =>
                          g.value === field.value,
                      ) || null
                    }
                    components={{ IndicatorSeparator: () => null }}
                    placeholder="구/군 선택"
                    maxMenuHeight={200}
                    isDisabled={!selectedRegion} // 시도가 선택되지 않았을 때 비활성화
                  />
                )}
              />
            </div>
          </div>
        </form>
      </SearchForm>
      <UserFavorList
        datas={listData}
        onRegisterSuccess={handleRegisterSuccess}
      />
      <Button
        title="선호 회사 목록 보기"
        fiexd
        onClick={clickHandlerListView}
      />
    </Container>
  );
};

export default UserFavorComp;

const Container = styled.div`
  padding: 2.4rem 1.5rem;
`;

const SearchForm = styled.div`
  .row-50 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.8rem;
    .cost-wrapper {
      div {
        > div {
          background-color: ${(props) => props.theme.costBgColor};
        }
      }
    }
  }
  form {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    .select-wrapper {
      padding: 1.1rem 1.1rem 1.5rem 1.5rem;
      background-color: ${(props) => props.theme.textWhiteColor};
      border: 1px solid ${(props) => props.theme.searchBoxBorderedColor};
      border-radius: 0.8rem;
      display: flex;
      flex-direction: column;
      font-size: 1.6rem;
      font-weight: 600;
      span {
        font-size: 1.2rem;
        font-weight: 600;
        color: ${(props) => props.theme.joinLabelColor};
        margin-bottom: 0.6rem;
        line-height: 1.5rem;
      }
      .search-select {
        .react-select__placeholder {
          color: ${(props) => props.theme.placeholderColor};
          font-weight: 400;
        }
        .react-select__control {
          background-color: transparent;
          min-height: 2rem;
          height: 2rem;
          border: none;
          .react-select__value-container {
            padding: 0;
          }
        }
        .react-select__indicator {
          padding: 0;
        }
      }
    }
    .checkbox {
      padding: 1.6rem 0;
      input[type='checkbox'] {
        display: none;
      }
      label {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 2.8rem;
        font-size: 1.3rem;
        font-weight: 600;
        &::after {
          content: '';
          width: 2.2rem;
          height: 2.2rem;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 2.2rem;
          height: 2.2rem;
          border-radius: 2.2rem;
          background: url('/assets/checkbox-nofill.svg');
          background-size: cover;
          background-position: center center;
          background-repeat: no-repeat;
        }
      }
      input[type='checkbox']:checked + label::after {
        background: url('/assets/checkbox-checked22px.svg');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
  }
`;
